import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import {Moment} from 'moment/moment';

import {DATE_MAX, DATE_MIN} from '../../app.constants';
import {LocalizationService} from '../localization/localization.service';

@Pipe({
  name: 'dateInfinity'
})
export class DateInfinityPipe implements PipeTransform {
  private readonly minDate: Moment;
  private readonly maxDate: Moment;

  constructor(public localizationService: LocalizationService) {
    this.minDate = moment(DATE_MIN);
    this.maxDate = moment(DATE_MAX);
  }

  transform(value: string | Date): string | Date {
    const date = moment(new Date(value));
    if (value && date.isValid()) {
      return date.isSameOrBefore(this.minDate, 'date') ? '- ∞'
        : date.isSameOrAfter(this.maxDate, 'date') ? '+ ∞'
          : date.format(this.localizationService.dateFormat);
    }
    return value;
  }

}
